import type { UserNotification } from './notification.model';

export type UserNotificationActions = AppendNotification | DismissNotification;

// =====================================================================
export function showNotification(notification: UserNotification) {
  return {
    type: 'SHOW_NOTIFICATION' as const,
    ...notification,
  };
}

export type AppendNotification = ReturnType<typeof showNotification>;

// =====================================================================

export function dismissNotification(id: string) {
  return {
    type: 'DISMISS_NOTIFICATION' as const,
    id,
  };
}

export type DismissNotification = ReturnType<typeof dismissNotification>;
